import { definitions as managedDefinitions } from './managed';
import { definitions as unmanagedDefinitions } from './unmanaged';

/**
 * Note: Do not change this array directly.
 *
 * Please use the `managedNudgeDefinitions` and `unmanagedNudgeDefinitions` arrays
 * to add new definitions depending on whether they are managed by CEM or not.
 */
export const definitions = [...managedDefinitions, ...unmanagedDefinitions];